"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var form_ejs_1 = require("./form.ejs");
exports.default = { form: form_ejs_1.default };
